<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-66">
            <form ref="site_document_plan_add" @submit.prevent="addPlan">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                        </div>
                        <h4 class="title">Ajout d'un plan</h4>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-75">
                                <md-field class="md-invalid">
                                    <label>Nom</label>
                                    <md-input v-model="name" name="name" type="text" required></md-input>
                                    <validation-error :errors="apiValidationErrors.name"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout mt-4">
                            <div class="md-layout-item md-size-75">
                                <md-field class="md-invalid">
                                    <label>Fichier</label>
                                    <md-file name="file" @change="selectFile"
                                             accept=".jpg,.jpeg,.png"></md-file>
                                    <validation-error marge="ml-2" :errors="apiValidationErrors.file"/>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">Enregistrer</md-button>
                        <md-button class="md-warning" @click="goBack">Retour
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
// Components
import {ValidationError} from "@/components";

// Mixins
import formMixin from "@/mixins/form-mixin";

export default {
    name: "PlanAdd",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    data() {
        return {
            name: '',
            file: null
        }
    },
    methods: {
        selectFile(e) {
            this.file = e.target.files[0]
        },
        async addPlan() {
            this.resetApiValidation()
            if(this.file) {
                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('fileName', this.formatFileName(this.file))
                formData.append('name', this.name)
                try {
                    const { data } = await this.$store.dispatch('site_documents/uploadSitePlan', formData)
                    let pathParts = data.split('/')
                    let document = {
                        name: this.name,
                        type: 2,
                        filePath: pathParts[4],
                        siteId: parseInt(this.$route.params.idSite)
                    }
                    const { data: plan } = await this.$store.dispatch('site_documents/addSiteDocument', document)
                    await this.$store.dispatch("alerts/success", "Plan ajouté")
                    await this.$router.push({ name: 'Site Plan Edit', params: { idSite: this.$route.params.idSite, documentId: plan.id } })
                } catch (e) {
                    this.setApiValidation(e.response.data.errors)
                }
            } else {
                this.setApiValidation([{
                    detail: 'Le fichier est requis.',
                    source: { pointer: '/data/attributes/file' }
                }])
            }
        },
        formatFileName(file) {
            let regex = /[ ]|'/g // search space and apostrophe
            return Math.floor(Math.random() * (9999 - 1000 + 1) + 1000) + '-' +
                file.name.toLowerCase().replaceAll(regex, '-')
        },
        goBack() {
            this.$router.back()
        }
    }
}
</script>

<style scoped>

</style>
